


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const FilecancelChequeReducer = function(state = initialState, action) {
switch (action.type) {
case Actions.FILE_CUSTOMER_CANCEL_CHEQUE:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.FILE_CUSTOMER_CANCEL_CHEQUE_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.FILE_CUSTOMER_CANCEL_CHEQUE_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
